export function getCookie(name: string) {
  const cookie: Record<string, unknown> = {};
  document.cookie.split(';').forEach(function (el) {
    const [k, v] = el.split('=');
    cookie[k.trim()] = v;
  });
  return cookie[name];
}

export function setCookie(name: string, value: string, days = 30) {
  const maxAge = days * 86400;
  document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${maxAge};SameSite=Lax`;
}
